import { createSlice } from "@reduxjs/toolkit";
import { updateDeliveryStatus } from "../../apis/dispense/updateDeliveryStatus";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const updateDeliveryStatusSlice = createSlice({
    name: 'updateDeliveryStatus',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(updateDeliveryStatus.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(updateDeliveryStatus.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(updateDeliveryStatus.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default updateDeliveryStatusSlice.reducer